import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    FieldSetDynamicStyleConstantType,
    FieldSetDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    container: {
        flexDirection: "column"
    }
});

export const useStyles = ({
    spaces
}: FieldSetDynamicStyleConstantType): FieldSetDynamicStyleType => {
    return {
        container: {
            gap: spaces.spacingLg
        } as Mutable<ViewStyle>
    };
};
export default stylesheet;
